import {getSSOUrl} from "@COMPONENTS/common/commonUtil";
import React from "react";

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
	href: string;
};

export default function SSOLink({href, onClick, children, target = "_self", ...props}: Props) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		// 기존 클릭 이벤트 실행
		if (onClick) onClick(e);

		// SSO 처리 후 리다이렉트
		getSSOUrl(href).then(redirectUrl => {
			window.open(redirectUrl, target);
		});
	};

	return (
		<a href={href} onClick={handleClick} {...props}>
			{children}
		</a>
	);
}
